import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiArrowRight, FiHome } = FiIcons;

const Navigation = ({ currentStep }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const steps = [
    { path: '/', label: 'Welcome' },
    { path: '/basic-info', label: 'Basic Info' },
    { path: '/niche', label: 'Niche' },
    { path: '/goals', label: 'Goals' },
    { path: '/action-plan', label: 'Action Plan' },
    { path: '/marketing-analysis', label: 'Analysis' },
    { path: '/complete-plan', label: 'Complete' }
  ];

  const currentStepIndex = steps.findIndex(step => step.path === location.pathname);

  const goToStep = (stepIndex) => {
    if (stepIndex >= 0 && stepIndex < steps.length && stepIndex <= currentStep) {
      navigate(steps[stepIndex].path);
    }
  };

  // Don't show navigation on welcome or complete page
  if (currentStepIndex === 0 || currentStepIndex === 6) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex justify-center mt-8"
    >
      <div className="bg-white rounded-full shadow-lg px-6 py-3">
        <div className="flex items-center space-x-4">
          <button
            onClick={() => goToStep(currentStepIndex - 1)}
            disabled={currentStepIndex <= 1}
            className={`p-2 rounded-full transition-all ${
              currentStepIndex > 1 
                ? 'text-blue-600 hover:bg-blue-100' 
                : 'text-gray-400 cursor-not-allowed'
            }`}
          >
            <SafeIcon icon={FiArrowLeft} />
          </button>
          
          <div className="flex items-center space-x-2">
            {steps.slice(1, -1).map((step, index) => (
              <button
                key={index}
                onClick={() => goToStep(index + 1)}
                disabled={index + 1 > currentStep}
                className={`w-3 h-3 rounded-full transition-all ${
                  index + 1 === currentStepIndex 
                    ? 'bg-blue-600' 
                    : index + 1 < currentStepIndex 
                      ? 'bg-green-500' 
                      : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
          
          <button
            onClick={() => goToStep(currentStepIndex + 1)}
            disabled={currentStepIndex >= 5}
            className={`p-2 rounded-full transition-all ${
              currentStepIndex < 5 
                ? 'text-blue-600 hover:bg-blue-100' 
                : 'text-gray-400 cursor-not-allowed'
            }`}
          >
            <SafeIcon icon={FiArrowRight} />
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default Navigation;